import React from 'react';
import {API_BASE_URL, CALLS_TYPES, PAGINATION_DEFAULT_LIMIT} from '../../../helpers/constants';
import {Button} from 'reactstrap';
import ReactTable from 'react-table';
import Pagination from '../../Pagination/Pagination';
import noImg from "../../../assets/images/img-error.svg";
import './calls-list.css';
import {I18n} from "../../../I18n/components/promoPage";

const CallsList = props => {
    const  calls = props.calls.filter(call => call.status === CALLS_TYPES.NEW ||
        call.status === CALLS_TYPES.ACCEPTED);
    let firstElementNumber = props.currentPage * PAGINATION_DEFAULT_LIMIT + 1;
    const currencies = props.basicOfferPrefs.currencies;
    const paymentModels = props.basicOfferPrefs.paymentModels;
    const tableData = calls.map((call, index) => {
        const offer = call.offer;
        return {
            count_id: firstElementNumber++,
            id: offer.id,
            app: {
                appLabel: offer.appLabel,
                offerId: offer.id
            },
            reward: {
                cost: offer.reward || 0,
                currency: currencies.length ? currencies[offer.currencyId - 1].name : '',
            },
            limit: {
                limit: offer.rewardLimit || '',
                currency: currencies.length ? currencies[offer.currencyId - 1].name : '',
            },
            employeeRewardPercent: call.employeeRewardPercent,
            paymentModel: paymentModels.length ? paymentModels[offer.paymentModelId - 1].name : '',
            specialOffer: offer.specialOffer,
            status: call.status,
            startDate: offer.startDate || 'none',
            actions: (
                call.status === CALLS_TYPES.NEW ? (
                    <div className="calls-actions">
                        <Button
                            onClick={() => props.updateCall({
                                id: call.id,
                                status: CALLS_TYPES.ACCEPTED
                            })}
                            color="gray-500"
                            size="sm"
                            round="true"
                            icon="true"
                            title={`${I18n[props.lang].accept}`}
                        >
                            <i className="fa fa-play"/>
                        </Button>
                        <Button
                            onClick={() => props.updateCall({
                                id: call.id,
                                status: CALLS_TYPES.DECLINED,
                                employeeRewardPercent: call.employeeRewardPercent
                            })}
                            color="danger"
                            size="sm"
                            round="true"
                            icon="true"
                            title={`${I18n[props.lang].decline}`}
                        >
                            <i className="fa fa-times"/>
                        </Button>
                    </div>
                ) : call.status === CALLS_TYPES.ACCEPTED ? (
                    <Button
                        onClick={() => props.updateCall({
                            id: call.id,
                            status: CALLS_TYPES.CANCELED,
                            employeeRewardPercent: call.employeeRewardPercent
                        })}
                        color="gray-500"
                        size="sm"
                        round="true"
                        icon="true"
                        title={`${I18n[props.lang].cancel}`}
                    >
                        <i className="fa fa-stop"/>
                    </Button>
                ) : null
            )
        };
    });
    return (
        <div className="user-table MyReactTableClass">
            <ReactTable
                getProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            border: "none",
                            padding: "5px"
                        }
                    };
                }}
                getTheadProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            boxShadow: "none",
                            padding: "10px 0",
                            fontWeight: "600",
                        }
                    };
                }}
                getTheadThProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            borderRight: "none",
                            whiteSpace: "pre-line"
                        }
                    };
                }}
                getTdProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            borderRight: "none",
                            textAlign: "center"
                        }
                    };
                }}
                getTrProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            alignItems: "center"
                        }
                    };
                }}
                getNoDataProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            top: "100%"
                        }
                    };
                }}
                columns={[
                    {
                        Header: "#",
                        accessor: "count_id",
                        sortable: false,
                        filterable: false,
                        style: {
                            textAlign: "center",
                            fontSize: "0.8rem",
                            textTransform: "lowercase"
                        },
                        maxWidth: 40
                    },
                    {
                        Header: `Приложение`,
                        accessor: "app",
                        sortable: true,
                        filterable: false,
                        minWidth: 200,
                        style: {
                            textAlign: "left",
                            fontSize: "0.8rem",
                        },
                        Cell: row => (
                            <div className="user-table__img">
                                <img
                                    src={`${API_BASE_URL}/trade/offer/icon/${row.value.offerId}`}
                                    alt="application logotype"
                                    className="img-fluid media-object"
                                    width="40"
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = noImg
                                    }}
                                />
                                <span>{row.value.appLabel}</span>
                            </div>
                        )
                    },
                    {
                        Header: `Вознаграждение`,
                        accessor: "reward",
                        sortable: false,
                        filterable: false,
                        maxWidth: 240,
                        minWidth: 130,
                        style: {
                            fontSize: "0.8rem",
                        },
                        Cell: row => (
                            <span>{`${row.value.cost} ${row.value.currency}`}</span>
                        )
                    },
                    {
                        Header: `Лимит`,
                        accessor: "limit",
                        sortable: false,
                        filterable: false,
                        maxWidth: 150,
                        style: {
                            fontSize: "0.8rem",
                        },
                        Cell: row => (
                            <span>{`${row.value.limit} ${row.value.currency}`}</span>
                        )
                    },
                    {
                        Header: `Процент сотрудника`,
                        accessor: "employeeRewardPercent",
                        sortable: false,
                        filterable: false,
                        maxWidth: 150,
                        style: {
                            fontSize: "0.8rem",
                        },
                        Cell: row => (
                            <span>{row.value ? `${row.value}%` : ``}</span>
                        )
                    },
                    {
                        Header: `Модель`,
                        accessor: "paymentModel",
                        sortable: false,
                        filterable: false,
                        maxWidth: 70,
                        style: {
                            fontSize: "0.8rem",
                            textTransform: "uppercase"
                        }
                    },
                    {
                        Header: `Условие для выплаты`,
                        accessor: "specialOffer",
                        sortable: false,
                        filterable: false,
                        minWidth: 300,
                        style: {
                            fontSize: "0.8rem",
                            textTransform: "lowercase"
                        }
                    },
                    {
                        Header: `Статус`,
                        accessor: "status",
                        sortable: false,
                        filterable: false,
                        maxWidth: 100,
                        style: {
                            fontSize: "0.8rem",
                            textTransform: "lowercase",
                        },
                        Cell: row => (
                            <span style={{
                                background: row.value === CALLS_TYPES.ACCEPTED ? '#3e69f6'
                                    : row.value === CALLS_TYPES.DECLINED ? '#1c97aa'
                                    : row.value === CALLS_TYPES.NEW ? '#57D500'
                                    : row.value === CALLS_TYPES.CANCELED ? '#dddddd'
                                    : row.value === CALLS_TYPES.STOPPED ? 'rgba(204,37,32,0.45)'
                                    : row.value === CALLS_TYPES.FINISHED ? 'rgba(45,107,0,0.73)' : '#000000',
                                padding: "3px 5px",
                                borderRadius: "45px",
                                color: "#ffffff"
                            }}>
								{
                                    row.value === CALLS_TYPES.ACCEPTED ? `Принят` :
                                    row.value === CALLS_TYPES.DECLINED ? `Отклонен` :
                                    row.value === CALLS_TYPES.NEW ? `Новый` :
                                    row.value === CALLS_TYPES.CANCELED ? `Отменен` :
                                    row.value === CALLS_TYPES.STOPPED ? `Остановлен` :
                                    row.value === CALLS_TYPES.FINISHED ? `Закончен` : 'none'
                                }
							</span>
                        )
                    },
                    {
                        Header: `${I18n[props.lang].offerList_startDate}`,
                        accessor: "startDate",
                        sortable: false,
                        filterable: false,
                        maxWidth: 110,
                        style: {
                            fontSize: "0.8rem",
                            textTransform: "lowercase"
                        },
                    },
                    {
                        Header: "",
                        accessor: "actions",
                        sortable: false,
                        filterable: false,
                        maxWidth: 150,
                    }
                ]}
                //manualSorting={true}
                //onSortedChange={props.sortBy}
                // defaultSorted={[{
                //     id   : props.sortState.id,
                //     desc : props.sortState.desc,
                // }]}
                //sort={[{id: props.sortState.id, desc: props.sortState.desc}]}
                PaginationComponent={Pagination}
                nextText={">>"}
                previousText={"<<"}
                //pageSize={50}
                //minRows={0}
                defaultPageSize={-1}
                pageSize={tableData.length}
                // showPaginationBottom={false}
                showPaginationBottom={props.totalPages > 1}
                className="-highlight"
                data={tableData}
                filterable
                // custom paginator settings
                manual
                onPageChange={props.setCurrentPage}
                page={props.currentPage}
                pages={props.totalPages}
            />
        </div>
    )
};

export default CallsList;



// WEBPACK FOOTER //
// ./src/components/Promo/Calls/CallsList.js